import cacheManagementApi from '@/api/cacheManagement';

const SET_CACHE = 'SET_CACHE';
const DELETE_CACHE = 'DELETE_CACHE';

const state = {
  cache: []
};

const getters = {
  getCache: state => {
    return state.cache;
  }
};

const mutations = {
  [SET_CACHE] (state, cache) {
    state.cache = cache;
  },
  [DELETE_CACHE] (state, ids) {
    ids.forEach(id => {
      const index = state.cache.map(e => e.id).indexOf(id);
      state.cache.splice(index, 1);
    });
  }
};

const actions = {
  retrieveCache ({state, commit}, {context}) {
    return new Promise((resolve, reject) => {
      cacheManagementApi.getCache(context).then(data => {
        commit(SET_CACHE, data);
        resolve();
      }, error => {
        reject(error);
      });
    });
  },
  deleteCacheElements ({commit}, {context, ids}) {
    return new Promise((resolve, reject) => {
      cacheManagementApi.deleteCacheElements(context, ids)
        .then(() => {
          commit(DELETE_CACHE, ids);
          resolve();
        }, error => {
          reject(error);
        });
    });
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/cacheManagement/index.js